const NUMBER_REGEX = /^[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?$/;
export const useInputValidation = ({ type, onChange, }) => {
    return (e) => {
        if (type === "number" &&
            !NUMBER_REGEX.test(e.currentTarget.value) &&
            e.currentTarget.value !== "" &&
            e.currentTarget.value !== "-") {
            return;
        }
        onChange(e);
    };
};
//# sourceMappingURL=useInputValidation.js.map